import { TextField, InputAdornment } from '@mui/material';
import React from 'react';
import AgentArrivalSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/components/AgentArrivalSelector';
import { RetirementSystem } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { parseNumericInput } from 'helpers/UIHelpers';
import NumberFormatCustom from 'components/NumberFormat/NumberFormatCustom';
import Flex from 'ui/Flex/Flex';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/AgentArrivalHypothesisModal/AgentArrivalForm';
import { useTranslation } from 'react-i18next';

type Props = {
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
};
export const AgentArrivalHypothesisNonIndiciaireStep = ({
    formState,
    setFormState,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseNumericInput(event.target.value);
        setFormState({
            ...formState,
            majoredSalary: newValue || 0,
        });
    };

    return (
        <Flex
            flexDirection="column"
            sx={{
                marginTop: '1em',
                gap: '2em',
            }}
        >
            <AgentArrivalSelector
                value={formState.retirementSystem}
                formState={formState}
                setFormState={setFormState}
                label={t('humanResources.simulation.addAgent.retirementSystem')}
                valueType="retirementSystem"
                dataList={Object.values(RetirementSystem)}
            />

            <TextField
                variant="outlined"
                required
                value={
                    formState.majoredSalary === 0 ? '' : formState.majoredSalary
                }
                label={t('humanResources.simulation.agentHypothesis.rawSalary')}
                onChange={onChange}
                sx={{ flex: 1 }}
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                    ),
                }}
            />
        </Flex>
    );
};
